export const GET_ALL_FOURNISSEUR_REQUEST = "GET_ALL_FOURNISSEUR_REQUEST";
export const GET_ALL_FOURNISSEUR_SUCCESS = "GET_ALL_FOURNISSEUR_SUCCESS";
export const GET_ALL_FOURNISSEUR_FAIL = "GET_ALL_FOURNISSEUR_FAIL";

export const ADD_FOURNISSEUR_REQUEST = "ADD_FOURNISSEUR_REQUEST";
export const ADD_FOURNISSEUR_SUCCESS = "ADD_FOURNISSEUR_SUCCESS";
export const ADD_FOURNISSEUR_FAIL = "ADD_FOURNISSEUR_FAIL";

export const UPDATE_FOURNISSEUR_REQUEST = "UPDATE_FOURNISSEUR_REQUEST";
export const UPDATE_FOURNISSEUR_SUCCESS = "UPDATE_FOURNISSEUR_SUCCESS";
export const UPDATE_FOURNISSEUR_FAIL = "UPDATE_FOURNISSEUR_FAIL";

export const DELETE_FOURNISSEUR_REQUEST = "DELETE_FOURNISSEUR_REQUEST";
export const DELETE_FOURNISSEUR_SUCCESS = "DELETE_FOURNISSEUR_SUCCESS";
export const DELETE_FOURNISSEUR_FAIL = "DELETE_FOURNISSEUR_FAIL";
